import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Simulator from "./components/Simulator";
import Rolplay from "./components/Rolplay";
import MessageForm from "./components/MessageForm";
import { useSession } from "./SessionContext";
import Bienvenida from "./components/Bienvenida";
import SimulatorSalinas from "./components/SimulatorSalinas";
import RolplaySalinas from "./components/RolplaySalinas";
import Dashboard from "./components/Dashboard";
import DashboardLacoste from "./components/Dashboard_lacoste";
import DashboardSomos from "./components/DashboardSomos";
import DashboardInter from "./components/DashboardInter";
import SimulatorSomos from "./components/SimulatorSomos";
import RolplaySomos from "./components/RolplaySomos";
import SimulatorGentera from "./components/SimulatorGentera";
import RolplayGentera from "./components/RolplayGentera";
import SimulatorHeineken from "./components/SimulatorHeineken";

function App() {
  const [view, setView] = useState(""); // Changed to empty string initially
  const [userKey, setUserKey] = useState("");
  const { updateSession } = useSession();
  const location = useLocation();
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isWelcomeExiting, setIsWelcomeExiting] = useState(false);

  // Efecto para los parámetros de URL y carga inicial
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const id_user = queryParams.get("id_user");
    const key = queryParams.get("key");

    if (id_user && key) {
      updateSession(id_user, key);
      setUserKey(key);

      // Set default view based on key
      if (key === "zBeMrw23") {
        setView("Dashboard");
      } else if (key === "WF5GHtHy3") {
        setView("DashboardLacoste");
      } else if (key === "BNn3s56A") {
        setView("DashboardSomos");
      } else if (key === "JIn0ds12a") {
        setView("DashboardInter");
      } else if (key === "izZDm5Kd15" || key === "AdTF02U57" || key === "fLqQiL38") {
        setView("Rolplay");
      } else if (key === "H1te2s03s") {
        setView("SimulatorHeineken");
      } else {
        setView("Simulator");
      }

      // Mostrar pantalla de bienvenida por 2 segundos
      const welcomeTimer = setTimeout(() => {
        setIsWelcomeExiting(true);
        setTimeout(() => {
          setIsInitialLoading(false);
        }, 500);
      }, 2000);

      return () => clearTimeout(welcomeTimer);
    }
  }, [location.search, updateSession]);

  // Esta función ahora solo maneja el cambio de vista
  const handleViewChange = (newView) => {
    setView(newView);
  };

  const renderView = () => {
    // If view is empty (initial state), return default view based on userKey
    if (!view) {
      if (userKey === "zBeMrw23") {
        return <Dashboard key="dashboard" />;
      } else if (userKey === "WF5GHtHy3") {
        return <DashboardLacoste key="DashboardLacoste" />;
      } else if (userKey === "BNn3s56A") {
        return <DashboardSomos key="DashboardSomos" />;
      } else if (userKey === "JIn0ds12a") {
        return <DashboardInter key="DashboardInter" />;
      } else if (userKey === "0kls2J4a1") {
        return <RolplayGentera key="rolplaygentera" />;
      } else if (userKey === "izZDm5Kd15" || userKey === "AdTF02U57" || userKey === "fLqQiL38") {
        return <Rolplay key="rolplay" />;
      } else {
        return <Simulator key="simulator" />;
      }
    }

    switch (view) {
      case "Dashboard":
        return <Dashboard key="dashboard" />;
      case "DashboardLacoste":
        return <DashboardLacoste key="DashboardLacoste" />;
      case "DashboardSomos":
        return <DashboardSomos key="DashboardSomos" />;
      case "DashboardInter":
        return <DashboardInter key="DashboardInter" />;
      case "SimulatorHeineken":
        return <SimulatorHeineken key="simulatorheineken" />;
      case "Simulator":
      case "simuladorfeed":
        return userKey === "zBeMrw23" ? (
          <SimulatorSalinas key="simulator" />
        ) : userKey === "BNn3s56A" ? (
          <SimulatorSomos key="simulator" />
        ) : userKey === "0kls2J4a1" ? (
          <SimulatorGentera key="simulator" />
        ) : (
          <Simulator key="simulator" />
        );
      case "Rolplay":
        return userKey === "zBeMrw23" ? (
          <RolplaySalinas key="simulator" />
        ) : userKey === "BNn3s56A" ? (
          <RolplaySomos key="rolplay" />
        ) : userKey === "0kls2J4a1" ? (
          <RolplayGentera key="rolplaygentera" />
        ) : (
          <Rolplay key="rolplay" />
        );
      case "message":
        return <MessageForm key="message" />;
      default:
        return userKey === "zBeMrw23" ? (
          <Dashboard key="dashboard" />
        ) : userKey === "WF5GHtHy3" ? (
          <DashboardLacoste key="DashboardLacoste" />
        ) : userKey === "BNn3s56A" ? (
          <DashboardSomos key="DashboardSomos" />
        ) : userKey === "JIn0ds12a" ? (
          <DashboardInter key="DashboardInter" />
        ) : (
          <Simulator key="simulator" />
        );
    }
  };

  // Mostrar pantalla de bienvenida durante la carga inicial
  if (isInitialLoading) {
    return <Bienvenida isExiting={isWelcomeExiting} />;
  }

  return (
    <div className="flex w-full min-h-screen bg-[#f2f2f2] text-gray-800">
      <Sidebar setView={handleViewChange} activeView={view} />
      <main className="flex-1 p-5 overflow-y-auto flex justify-center items-center">
        {renderView()}
      </main>
    </div>
  );
}

export default App;
